<div *ngIf="showConversionWarning" class="mb-2">
  <app-alert type="info" theme="dark">
    <div class="text-bold">We've updated your labels</div>
    <div>The labels in this model have been updated from the Dark (Classic) theme to the new interactive Light theme.</div>

    <div class="pt-2">
      <button app-button buttonSize="small" class="mr-1" (click)="handleOkClick()">Ok</button>
      <button app-button buttonSize="small" (click)="handleUndoClick()">Undo</button>
    </div>

  </app-alert>
</div>